import React, { useEffect, useState } from "react";
import { FootballMatch } from "../../../../types/eventTypes";
import {searchMatchDay} from "../../../../queries/filterUtilsQueries";
import CustomAutoComplete from "../CustomAutoComplete";
import { ActiveFilters } from "@/types/filterTypes";

interface MatchSearchProps {
    label?: string;
    value: FootballMatch | null;
    onChange: (value: FootballMatch) => void;
    freeSolo: boolean;
    additionalFilters?: ActiveFilters;
    disabled?: boolean;
    multiple?: boolean;
    readOnly?: boolean;
}

const MatchSearch: React.FC<MatchSearchProps> = ({
                                                     value,
                                                     label,
                                                     onChange,
                                                     freeSolo,
                                                     additionalFilters,
                                                     disabled = false,
                                                     multiple = false,
                                                     readOnly = false,
                                                 }) => {
    const [query, setQuery] = useState<string>("");
    const [matchDayOptions, setMatchDayOptions] = useState<FootballMatch[]>([]);

    const onQueryChange = (newQuery: string) => {
        setQuery(newQuery);
    };

    useEffect(() => {
        const fetchOptions = async () => {
            const matchDays = await searchMatchDay(query, additionalFilters);
            setMatchDayOptions(matchDays);
        };


        const delayDebounceFn = setTimeout(() => {
            fetchOptions();
        }, 500);


        return () => clearTimeout(delayDebounceFn);

    }, [query, additionalFilters]); // Si attiva ogni volta che la query o i filtri cambiano

    return (
        <CustomAutoComplete
            label={label}
            options={matchDayOptions}
            value={value}
            onChange={(_: any, newValue: any) => onChange(newValue)}
            customAutocomplete={false}
            textFieldValue={query || ''}
            textFieldOnChange={(value: string) => onQueryChange(value)}
            multiple={multiple}
            labelField={'value'}
            valueField={'id'}
            freeSolo={freeSolo}
            data-tour={"goal-parade-filter-matchday"}
            disabled={disabled}
            readOnly={readOnly}
        />
    );
};

export default MatchSearch;